import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useNotificationPreferencesApi } from '../use-notification-preferences-api';

export const getNotificationPreferencesQueryKey = (orgId: string) => [
  orgId,
  'notification-preferences',
  'get-notification-preferences',
];

export const useGetNotificationPreferences = () => {
  const preferencesApi = useNotificationPreferencesApi();
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  return useQuery({
    queryFn: () =>
      preferencesApi.getOrganizationPreferences({
        organizationUUID: organizationId,
      }),
    queryKey: getNotificationPreferencesQueryKey(organizationId),
  });
};
